// This is a skeleton starter React component generated by Plasmic.
// This file is owned by you, feel free to edit as you see fit.
import * as React from "react";
import {PlasmicHomepage} from "./plasmic/blank_website_mobile_first/PlasmicHomepage";
import {AppStore, useBackgroundAuth} from "../useAppPullState";
import Header from "./Header";
import WithLogo from "./WithLogo";

import MiniHeader from "./MiniHeader";
import TabComponent from "./Tabs";
import MiniList from "./MiniList";
import {LoginPage} from "../LoginPage";
import {useDesktop} from "./useDesktop";
import DesktopList from "./DesktopList";
import {useAuth} from "../service/firebase";
import {ResetPassword} from "../ResetPassword";
import {ResetPasswordState} from "../hooks/useResetPageAction";
import {LinkLogin} from "../hooks/useMagicLoginPageAction";
import {MagicLink} from "../MagicLink";
import {Typography} from "antd";
import {SelectHomeCourseModal} from "./modal/SelectHomeCourseModal";
import {SelectHomeCourseModalStore} from "./modal/SelectHomeCourseModalStore";
import {isPaidMember} from "./selectors/membersPaid";

const useMembership = () => {
    const {
        user
    } = AppStore.useState(s => ({
        user: s.user
    }));


    const {homeCourse, locations} = SelectHomeCourseModalStore.useState();

    const id = homeCourse?.courseId;
    const selectedCourse = locations.find(loc => loc.id === id);
    const isPaid = isPaidMember(user);
    return {
        homeCourse: {
            // children: "No home course",
            // suomi
            children: selectedCourse ? (
                <Typography.Text style={{
                    fontSize: '20px',
                    color: 'white'
                }}>{`${selectedCourse.title}, ${selectedCourse.abbreviation}`}</Typography.Text>
            ) : (
                <Typography.Text type="warning" style={{fontSize: '20px'}}>Ei Nimetty pelioikeus
                    kenttä</Typography.Text>
            )
        },
        homeCourseChangeBtn: {
            onClick: () => {
                SelectHomeCourseModalStore.update(s => {
                    s.visible = true;
                    s.selectedHomeCourse = s.homeCourse?.courseId;
                });
            }
        },
        noMembership: user?.newMember,
        delayed: !isPaid
    }
}


const useHomeUI = () => {
    const viewState = useViewState();
    const isDesktop = useDesktop();
    const membership = useMembership();
    useAuth();
    return {
        viewState,
        membership,
        header: <Header/>,
        miniHeader: <MiniHeader/>,
        tabs: <TabComponent/>,
        admin: {
            children: null
        },
        courses: {
            children: isDesktop ? (
                <DesktopList/>
            ) : (
                <MiniList/>
            )
        },
        login: {
            children: (
                <WithLogo>
                    <LoginPage/>
                </WithLogo>

            )
        },
        resetPassword: {
            children: (
                <WithLogo>
                    <ResetPassword/>
                </WithLogo>
            )
        },
        magicLink: {
            children: (
                <WithLogo>
                    <MagicLink/>
                </WithLogo>
            )
        }
    }
}

const useViewState = () => {
    const {showMembership, loginPage, showHistory, user} = AppStore.useState(s => ({
        showMembership: s.showMembership,
        loginPage: s.loginPage,
        showHistory: s.showHistory,
        user: s.user
    }));

    const isReset = ResetPasswordState.useIsReset();
    const isMagicLink = LinkLogin.useIsMagicLogin();
    const isPaid = isPaidMember(user);

    ResetPasswordState.useParamsToDefineToken();
    LinkLogin.useParamsToDefineToken();

    // return "admin"

    if (isReset) {
        return "resetPassword";
    }

    if (!user && isMagicLink) {
        return "magicLink";
    }


    if (isMagicLink) {
        //remove secret from url with history.replace
        window.history.replaceState({}, document.title, window.location.pathname);
    }

    // console.log("[[useViewState]]", user);
    if (user?.newMember || (user && !isPaid)) {
        return "membership";
    }

    if (loginPage) {
        return "login";
    } else if (showMembership) {
        return "membership";
    } else if (showHistory) {
        return "history";
    } else {
        return "courses";
    }
}


const useProps = (props) => {
    const [close, setClose] = React.useState(false);

    const {
        loginPage,
        showMembership,
        user,
        showHistory,
        loading
    } = AppStore.useState(s => ({
        reloadData: s.reloadData,
        loginPage: s.loginPage,
        showMembership: s.showMembership,
        user: s.user,
        showHistory: s.showHistory,
        golfCourses: s.golfCourses,
        bookings: s.bookings,
        loading: s.loading
    }));
    useBackgroundAuth();

    const noAuthorization = close ? false : !user && !loginPage && !showMembership && !showHistory && !loading;

    return {
        ...props,
        ...useHomeUI(props),
        loginPage,
        showMembership,
        user,
        showHistory,
        loading,
        noAuthorization: noAuthorization,
        closeBtn: {
            onClick: () => {
                setClose(true);
            }
        },
        loginBtn: {
            onClick: () => {
                AppStore.update(s => {
                    s.loginPage = true;
                })
            }
        }
    }
}

function Homepage_(props, ref) {
    return <>
        <SelectHomeCourseModal/>
        <PlasmicHomepage root={{ref}} {...useProps(props)} />
    </>
}

const Homepage = React.forwardRef(Homepage_);

export default Homepage;
